import React, { useState } from 'react'
import "../contact.css"
import { ReactComponent as ContactArteologo } from '../images/contactarttteologo.svg'
import contactimage from '../images/unsplash_kVg2DQTAK7c.png'
import { TiSocialLinkedin } from "react-icons/ti";



const Contact = () => {
    const [selectedBudget, setSelectedBudget] = useState(null);
    const handleBudgetClick = (budget) => {
        setSelectedBudget(budget); // Set the selected budget when a list item is clicked.
    };
    return (
        <div className='contact-page'>
            <header>
                <div className="logo">
                    <ContactArteologo />
                    <div className='logo-title'>
                        <strong>Arttteo</strong>
                        <p>Software Development</p>
                    </div>

                </div>
                <nav className="header-links">
                    <ul>
                        <li><a href="">How to use</a></li>
                        <li><a href="">Step-by-Step Guide</a></li>
                        <li><a href="">Benefits</a></li>
                        <li><a href="">Testimonials</a></li>
                        <li><a href="">FAQ</a></li>
                        <li><a href="">Contact</a></li>
                    </ul>
                </nav>
                <button> Talk to us</button>
            </header>
            <p className='contact-page-greentitle'>Connect with us</p>
            <h1 className='contact-page-bigtitle'>Let's dive into your project!</h1>
            <div className="contact-main">
                <form action="" className="contact-left">
                    <h1>Get in touch</h1>
                    <input type="text" placeholder='Full name' />
                    <input type="mail" placeholder='Business Email' />
                    <input type="text" placeholder='How did find us?' />
                    <input type="text" placeholder='Company Name' />
                    <input type="text" placeholder='How did you hear about us?' />
                    <div className="yourbudget">
                        <p>What is your budget?</p>
                        <div className="budget-buttons">
                            {['Up to 25,000 $', '25,000 - 50,000 $', '50,000 to 100,000 $', '100,000 to 250,000 $', 'Over 250,000 $', "Can't disclose"].map((budget) => (
                                <li
                                    key={budget}
                                    onClick={() => handleBudgetClick(budget)}
                                    className={selectedBudget === budget ? 'selected-budget' : ''}
                                >
                                    {budget}
                                </li>
                            ))}
                        </div>
                    </div>
                    <textarea name="" id="" rows={8} placeholder='Your company needs'></textarea>
                    <button className='contact-submit'>Submit form</button>
                </form>
                <div className="contact-right">
                    <div className="contact-frame-background"></div>
                    <img className='img-rounded' src={contactimage} alt="" />
                    <div className="name-linkedin">
                        <strong>Rezi Parulava</strong>
                        <span><TiSocialLinkedin /></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact